import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import * as Yup from "yup";
import Error from "../../components/messagesModal/error";
import Validation from "../../utils/validation";
import { actions as actionsSite } from "../../redux/actions/site";
import DefaultForm from './DefaultForm';
import { getComponents } from "./componentesForms";
import { slugToPascalCase } from "../../utils/converts";

const Consultas = () => {
  new Validation(Yup);
  const profile = useSelector((state) => state.auth.profile);

  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const [query, setQuery] = useState(null);

  const renderComponent = () => {
    const components = getComponents();
    const Component = components[slugToPascalCase(query.code)];

    if (Component) return <Component/>;

    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <span className="mx-1">
          Consulta não possui formulário no momento.
        </span>
      </div>
    );
  };

  const getQuery = useCallback(async () => {
    const code = location.pathname.split("/").pop();
    const query = profile.permissionsQueries.find((q) => q.code === code);
    return query;
  },[profile, location]);

  useEffect(() => {
    const run = async () => {
      const _query = await getQuery();

      if (!_query) {
        const configModal = {
          component: <Error msg='Consulta não encontrada'/>,
          title: 'Erro',
        };
        dispatch(actionsSite.setModal(configModal));
        history.push("/dashboard");
        return;
      }

      setQuery(_query);
    };

    run();
  }, [location, history, getQuery, dispatch]);

  return (
    <div className="consultas">
      <Breadcrumb>
        <BreadcrumbItem>
          <Link to="/">Dashboard</Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>Consultas</BreadcrumbItem>
      </Breadcrumb>

      {query && query.customInputs ? (
        renderComponent()
      ) : (
        <DefaultForm/>
      )}
    </div>
  );
};

export default Consultas;
